<template>
<div class="Qpage">
  <Page1 v-bind:items="items">
  </Page1>
</div>
</template>

<script>
import Page1 from './Page1.vue'

export default {
  name: 'Qpage',
  components: {
    Page1
  },
  data() {
    return {
      items: [{
          Q: ''
        },
        {
          Q: '会社の10年後の夢について語り合える後継者候補がいますか。'
        },
        {
          Q: '候補者本人に対して、会社を託す意思があることを明確に伝えましたか。'
        },
        {
          Q: '候補者に対する経営者教育や、人脈・技術等の引継ぎなど<br class="sp_br" >具体的準備を進めていますか。'
        },
        {
          Q: '役員や従業員、取引先などの関係者の理解や協力が<br class="sp_br" >得られるよう取り組んでいますか。'
        },
        {
          Q: '事業承継に向けた社内の準備<br class="sp_br" >（財務・税務・人事等の総点検）に取りかかっていますか。'
        },
        {
          Q: '事業承継の準備についての相談先はありますか。'
        },
        {
          Q: '親族内や役員・従業員のなかで後継者候補にしたい人材はいますか。'
        },
        {
          Q: '事業承継を行うためには、候補者を説得し、合意を得た後、後継者教育や引継ぎなどを行う準備期間が必要です。準備時間を十分にとることができますか。'
        },
        {
          Q: '候補者に承継の打診をしていない理由は明確ですか。<br class="sp_br" >（後継者候補が若すぎるなど）'
        },
        {
          Q: ''
        },
        {
          Q: 'Q1'
        },
        {
          Q: 'Q2'
        },
        {
          Q: 'Q3'
        },
        {
          Q: 'Q4'
        },
        {
          Q: 'Q5'
        },
        {
          Q: 'Q6'
        },
        {
          Q: 'Q7'
        },
        {
          Q: 'Q8'
        },
        {
          Q: 'Q9'
        }
      ]
    }
  }
}
</script>
